<div class="d-flex modal-body flex-column overflow-hidden h-100">
    <div class="flex-grow-1 d-flex flex-column overflow-hidden">
        <ng-container *ngIf="files">
            <app-images-select
                [class.disabled]="isUploading"
                (selectionChange)="selectedFiles = $event"
                [options]="files"
            />
        </ng-container>
    </div>

    <div *ngIf="isUploading" class="direct-upload-status mx-2 mt-3" role="status" aria-live="polite">
        <div class="d-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm flex-shrink-0 text-primary" aria-hidden="true"></span>
            <div class="min-width-0 flex-grow-1">
                <div class="d-flex justify-content-between gap-2">
                    <strong class="text-truncate">上传进度</strong>
                    <span class="text-muted flex-shrink-0">{{ completedFileCount }}/{{ totalFileCount }}</span>
                </div>
                <small class="text-muted">{{ transferProgress }}%</small>
            </div>
        </div>
        <div
            class="progress direct-upload-progress mt-2"
            role="progressbar"
            aria-label="上传美国平台进度"
            aria-valuemin="0"
            aria-valuemax="100"
            [attr.aria-valuenow]="transferProgress"
        >
            <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                [style.width.%]="transferProgress"
            ></div>
        </div>
    </div>

    <div *ngIf="uploadErrors.length > 0" class="upload-errors mx-2 mt-3" role="alert">
        <strong>以下附件上传失败，可重试：</strong>
        <ul class="mb-0 mt-1 ps-3">
            <li *ngFor="let error of uploadErrors">{{ error }}</li>
        </ul>
    </div>

    <div style="text-align: right" class="mt-3 pe-2 pb-2">
        <p-button
            label="取消"
            class="me-2"
            [text]="true"
            styleClass="p-button-text p-button-sm p-button-secondary"
            [disabled]="isUploading"
            (onClick)="onCancel()"
        />
        <p-button
            label="上传美国平台"
            [text]="true"
            styleClass="p-button-text p-button-sm p-button-info"
            [disabled]="isUploading || !selectedFiles || selectedFiles.length <= 0"
            [loading]="isUploading"
            (onClick)="onUpload()"
        />
    </div>
</div>
